export function SignupSupport({ className = "" }: { className?: string }) {
  return <p className={`signup-support-links ${className}`}>Need a hand? Email <a href="mailto:support@chekkit.io">support@chekkit.io</a> or call <a href="tel:+14318035862">431 803 5862</a>.</p>;
}
